import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/landlink-page.css";
import "./styles/bizpulse-page.css";
import App from "./App.tsx";
import { LocaleProvider } from "./i18n";
import { captureRef } from "./lib/track";

captureRef();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LocaleProvider>
      <App />
    </LocaleProvider>
  </StrictMode>
);
